module.exports = __webpack_public_path__ + "static/media/zhengs2-1.5edd8a65.png";